var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWifiGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.00025C7 -0.66675 15 -0.66675 21 6.00025M5 10.0002C8.6 6.00025 13.4 6.00025 17 10.0002",
    stroke: "#737374",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.0005C11.5523 15.0005 12 14.5528 12 14.0005C12 13.4482 11.5523 13.0005 11 13.0005C10.4477 13.0005 10 13.4482 10 14.0005C10 14.5528 10.4477 15.0005 11 15.0005Z",
    stroke: "#737374",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifiGray);
export default __webpack_public_path__ + "static/media/IconWifiGray.f3c67fb026ed8109284a27a002b63111.svg";
export { ForwardRef as ReactComponent };